import { useQuery } from '@tanstack/react-query';
import { getFullPrequalResult } from '../api/api';
import type { PersonalFinanceEnvironment } from '../types';

export default function usePrequalResult(
  environment: PersonalFinanceEnvironment,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['pfcPrequalResult', environment],
    queryFn: () => getFullPrequalResult(environment),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: false,
  });
}
